import type { ScopeActivationItem } from "@/api/scope-activation";

export type Verdict = ScopeActivationItem["verdict"];

export interface VerdictMeta {
  label: string;
  // classes Tailwind pro badge (fundo + texto)
  badge: string;
  // cor sólida das barras empilhadas (usa as mesmas famílias do badge)
  bar: string;
}

// Cores de veredito do app. Reaproveitadas pelo Catálogo, worklist e barras.
export const VERDICT_META: Record<Verdict, VerdictMeta> = {
  activate: {
    label: "Activate",
    badge: "bg-emerald-100 text-emerald-700",
    bar: "bg-emerald-500",
  },
  needs_decision: {
    label: "Decision",
    badge: "bg-amber-100 text-amber-700",
    bar: "bg-amber-500",
  },
  needs_review: {
    label: "Review",
    badge: "bg-orange-100 text-orange-700",
    bar: "bg-orange-500",
  },
  skip: {
    label: "Not applicable",
    badge: "bg-gray-100 text-gray-500",
    bar: "bg-gray-300",
  },
};

export const VERDICT_ORDER: Verdict[] = [
  "activate",
  "needs_decision",
  "needs_review",
  "skip",
];

export function verdictLabel(v: string): string {
  return (VERDICT_META as Record<string, VerdictMeta>)[v]?.label ?? v;
}
